<template>
  <div class="user-information">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户基本信息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list">
      <ul>
        <li>姓名：<span>{{userInformation.name}}</span></li>
        <li>性别：<span>{{userInformation.gender}}</span></li>
        <li>民族：<span>{{userInformation.nation}}</span></li>
        <li>出生日期（与身份证一致）：<span>{{userInformation.birthday}}</span></li>
        <li>文化程度：<span>{{userInformation.culture}}</span></li>
        <li>婚姻状况：<span>{{userInformation.marriage}}</span></li>
        <li>和谁住在一起：<span>{{userInformation.live}}</span></li>
        <li>工作状况：<span>{{userInformation.work_status}}</span></li>
        <li>工作或退休前曾经的工作岗位：<span>{{userInformation.position}}</span></li>
        <li>经济状况：<span>{{userInformation.economy}}</span></li>
        <li>长期居住地：<span>{{userInformation.address}}</span></li>
        <li>主要通过什么设备上网：<span>{{userInformation.internet_equipment}}</span></li>
        <li>一周中，平均每天上网几个小时：<span>{{userInformation.internet_time}}</span></li>
        <li>主要使用哪种社交媒体：<span>{{userInformation.social_media}}</span></li>
      </ul>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        userInformation:{}
      }
    },
    methods: {
      getInformation(){
        this.$get('/v1/user-basic-info?id=' + this.$route.query.user_id, {})
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.userInformation = res.data.data.data;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
    },
    created() {
      this.getInformation();
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .user-information
    .list
      min-height 550px
      margin-top 20px
      border 1px solid #EBEEF5
      li
        width 100%
        padding-left 20px
        line-height 40px
        border-bottom 1px dashed #eee
        span
          color #888

</style>



// WEBPACK FOOTER //
// src/pages/UserManage/UserInformation.vue